(() => {
  const productHeadingByPath = {
    '/products/black-glasses': 'ROMA / MATOWE CZARNE OKULARY OCHRONNE',
    '/products/grey-glasses': 'ROMA / SZARE OKULARY OCHRONNE',
    '/products/clear-glasses': 'ROMA / PRZEZROCZYSTE OKULARY OCHRONNE'
  };
  const currentProductHeading = productHeadingByPath[window.location.pathname];

  const translations = new Map([
    ['ROMA / MATOWE CZARNE OKULARY OCHRONNE', currentProductHeading || 'ROMA / MATOWE CZARNE OKULARY OCHRONNE'],
    ['Color:', 'Kolor:'],
    ['Black', 'Czarny'],
    ['Availability', 'Dostępność'],
    ['Price', 'Cena'],
    ['FAQs', 'FAQ']
  ]);

  function translateAttributes(root) {
    const elements = [];
    if (root?.nodeType === Node.ELEMENT_NODE && root.matches?.('[aria-label], [title]')) elements.push(root);
    if (root?.querySelectorAll) elements.push(...root.querySelectorAll('[aria-label], [title]'));
    for (const element of elements) {
      for (const attribute of ['aria-label', 'title']) {
        const value = element.getAttribute(attribute);
        if (!value) continue;
        const translated = value.replace(/\bColor\b/g, 'Kolor').replace(/\bBlack\b/g, 'Czarny');
        if (translated !== value) element.setAttribute(attribute, translated);
      }
    }
  }

  function translate(root = document.body) {
    if (!root) return;
    translateAttributes(root);
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    for (const node of nodes) {
      const parent = node.parentElement;
      if (!parent || parent.closest('script, style, textarea, [contenteditable="true"]')) continue;
      const original = node.nodeValue || '';
      const trimmed = original.trim();
      const translated = translations.get(trimmed);
      if (!translated) continue;
      node.nodeValue = original.replace(trimmed, translated);
    }
  }

  function start() {
    translate();
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.type === 'characterData') {
          translate(mutation.target.parentElement);
          continue;
        }
        if (mutation.type === 'attributes') {
          translateAttributes(mutation.target);
          continue;
        }
        for (const node of mutation.addedNodes) {
          if (node.nodeType === Node.TEXT_NODE) translate(node.parentElement);
          else if (node.nodeType === Node.ELEMENT_NODE) translate(node);
        }
      }
    });
    observer.observe(document.body, {
      childList: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['aria-label', 'title'],
      subtree: true
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
